import React from 'react'
import {
  positiveParentingTips0To9Months,
  positiveParentingTips12To18Months,
  positiveParentingTips24To36Months,
  positiveParentingTips48MonthsOnward,
} from './positive_parenting_tips'
import {
  healthyBodies0To9Months,
  healthyBodies12To18Months,
  healthyBodies24To36Months,
  healthyBodies48MonthsOnward,
} from './healthy_bodies'
import {
  childSafetyFirst0To9Months,
  childSafetyFirst12To36Months,
  childSafetyFirst48MonthsOnward,
} from './child_safety_first'

export const IMAGE = 'image'
export const VIDEO = 'video'

export const concernedCard = {
  style: 'concerned_card',
  title: 'Concerned About Your Child’s Development? Act Early.',
  body: [
    <><b>Tell your child’s doctor or nurse if you notice any of these signs of possible developmental delay for this age and ask for a developmental screening.</b> Talk with someone in your community who is familiar with services for young children in your area, such as your state’s public early intervention program. For more information, <a href='https://www.cdc.gov/ncbddd/actearly/concerned.html'>visit our “If You’re Concerned” web page</a> or call <b>1-800-CDC-INFO.</b></>
  ]
}

export const positiveParentingTips = (ageInMonths) => {
  if (ageInMonths <= 9) { return positiveParentingTips0To9Months }
  if (ageInMonths <= 18) { return positiveParentingTips12To18Months }
  if (ageInMonths <= 36) { return positiveParentingTips24To36Months }
  return positiveParentingTips48MonthsOnward
}

export const healthyBodies = (ageInMonths) => {
  if (ageInMonths <= 9) { return healthyBodies0To9Months }
  if (ageInMonths <= 18) { return healthyBodies12To18Months }
  if (ageInMonths <= 36) { return healthyBodies24To36Months }
  return healthyBodies48MonthsOnward
}

export const childSafetyFirst = (ageInMonths) => {
  if (ageInMonths <= 9) { return childSafetyFirst0To9Months }
  if (ageInMonths <= 36) { return childSafetyFirst12To36Months }
  return childSafetyFirst48MonthsOnward
}
